import { registerApplication, start } from 'single-spa'
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine
} from 'single-spa-layout'
import { Util } from './utilities'
import { Sesion } from './sesion'

function getMicrofronts(url) {
  const localMicrofronts = localStorage.getItem('microfronts')
  console.log(localMicrofronts)
  if (localMicrofronts != null && localMicrofronts != 'null') {
    const body = JSON.parse(localMicrofronts)
    console.log("Microfronts:", body);
    createMicrofronts(body)
  } else {
    fetch(url)
      .then((res) => {
        if (res.status === 200) {
          res.json().then((body) => {
            localStorage.setItem('microfronts', JSON.stringify(body))
            console.log("fetch")
            createMicrofronts(body)
          })
        }
      })
      .catch((e) => {
        console.log('Falló la petición de los microfront ' + e.message, e)
        console.error('Falló la petición de los microfront ' + e.message, e)
      })
  }
}

function createMicrofronts(body) {
  let routesDef = Util.getRoutesDef()
  let loaders = []
  Sesion.login()
    .then((isOk: boolean) => {
      console.log("isOK: ", isOk);
      if (isOk) {
        const respuestaMicrofront = Util.registrarMicrofronts(
          routesDef,
          loaders,
          body
        )
        loaders = respuestaMicrofront.loaders
        routesDef = respuestaMicrofront.routesDef

        console.info("respuestaMicrofront: ", respuestaMicrofront)
        console.info("body: ", body)

        const routes = constructRoutes(routesDef)
   
        const applications = constructApplications({
          routes,
          loadApp({ name }) {
            const loaderConfig = loaders.find(item => item.name === name);
            return System.import(loaderConfig.loader);
          }
        })

        console.info("routes: ", routes)
        console.info("applications: ", applications)

        const layoutEngine = constructLayoutEngine({ routes, applications })

        console.info("layoutEngine: ", layoutEngine)

        layoutEngine.activate()
        applications.forEach(app => {
          const loaderConfig = loaders.find(item => item.name === app.name);
          registerApplication({
            ...app,
            customProps: {
              mfBaseUrl: loaderConfig.loader.replace(/\/[^/]+$/, '')
            }
          });
        });
        start()
        document.getElementById('loading-factoring').classList.add('hide')
      } else {
        // Cuando falla el api de solicitar token
        console.error('Falló al autenticar')
        Util.openInTab(process.env.urlSSO)
      }
    })
    .catch((e) => {
      console.log("Error")
      console.log(e)
    })
}

// const url = 'http://localhost:4000/microfront'
const url = `${process.env.bffUri}/api/backoffice/appshell/microfront`
getMicrofronts(url)
